import { render, staticRenderFns } from "./MatchEvent.vue?vue&type=template&id=4ff8247b&scoped=true"
import script from "./MatchEvent.vue?vue&type=script&lang=js"
export * from "./MatchEvent.vue?vue&type=script&lang=js"
import style0 from "./MatchEvent.vue?vue&type=style&index=0&id=4ff8247b&prod&lang=scss&scoped=true"
import style1 from "./MatchEvent.vue?vue&type=style&index=1&id=4ff8247b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8247b",
  null
  
)

export default component.exports